import React, { useState, useEffect } from "react";
import axios from "axios";
import RecorderJS from "recorder-js";
import { getAudioStream, exportBuffer } from "../utils/audio";

const Record = ({ memo, setMemo }) => {
  const [record, setRecord] = useState(false);
  const [stream, setStream] = useState(null);
  const [recorder, setRecorder] = useState(null);

  useEffect(() => {
    const getMic = async () => {
      let stream;
      try {
        stream = await getAudioStream();
      } catch (error) {
        console.log(error);
      }
      setStream(stream);
    };
    getMic();
  }, []);

  const start = () => {
    const audioContext = new (window.AudioContext ||
      window.webkitAudioContext)();

    const recorder = new RecorderJS(audioContext);
    recorder.init(stream);

    setRecorder(recorder);
    setRecord(true);
  };
  useEffect(() => {
    if (record === true) {
      recorder.start();
    }
  }, [recorder, record]);

  const stop = async () => {
    const { buffer } = await recorder.stop();
    const audio = exportBuffer(buffer[0]);

    setRecord(false);
    const formData = new FormData();
    formData.append("wavfile", audio, "memmify.wav");

    axios
      .post("/sox", formData, {
        headers: {
          "content-type": "multipart/form-data",
        },
      })
      .then((res) => {
        const url = res.data.url;
        fetch(url)
          .then((res) => res.blob()) // Gets the response and returns it as a blob
          .then((blob) => {
            const formDataX = new FormData();

            formDataX.append("wavfile", blob, "memmify.wav");
            formDataX.append("outputlevel", "--uttlevel");
            formDataX.append("outputformat", "--json");
            axios
              .post("https://api.aiforthai.in.th/partii-webapi", formDataX, {
                headers: {
                  Apikey: "bXagwMODVlCkp1fxJm7jyZjwy22D81G5",
                },
              })
              .then((res) => {
                let theData = JSON.parse(res.data.message)[0].result;
                const theMemo = memo + theData;
                setMemo(theMemo);
              })
              .catch((e) => {
                console.log(e);
                setTimeout(() => {
                  // setLoad(false);
                }, 500);
              });
          });
      });
  };

  return (
    <div>
      <div
        onClick={() => {
          if (record === true) {
            stop();
          } else start();
        }}
        className={`${
          record !== true
            ? "hover:bg-gray-600 bg-gray-500"
            : "hover:bg-red-600 bg-red-500"
        } m-0 mr-3 p-3 font-bold  text-white rounded-md cursor-pointer w-12 flex justify-center items-center`}
      >
        {record === false || record === null ? (
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"
            />
          </svg>
        ) : (
          <svg
            className="w-6 h-6 animate-spin"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 10a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z"
            />
          </svg>
        )}
      </div>
    </div>
  );
};

export default Record;
